export const BASE_SIZE = 1024;

export const sizeUnits = {
    B: 1,
    KB: BASE_SIZE,
    MB: BASE_SIZE * BASE_SIZE,
    GB: BASE_SIZE * BASE_SIZE * BASE_SIZE,
    TB: BASE_SIZE * BASE_SIZE * BASE_SIZE * BASE_SIZE,
};
